import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useSidebar } from "../../SidebarContext";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import Header from "../Header";
import Sidebar from "../SideBar";
import {
  ArrowLeftIcon,
  PenIcon,
  Trash2Icon,
  FileText,
} from "lucide-react";
import ExpenseModal from "../ExpenseModal";
import { decryptToken } from "../utils/getToken";

const ExpenseDetail = () => {
  const { isSidebarOpen } = useSidebar();
  const [customers, setCustomers] = useState([]);
  const { id } = useParams();
  const [expense, setExpense] = useState(null);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const navigate = useNavigate();
  const url = process.env.REACT_APP_LINK;
  const user = getDecryptedUserFromCookie("gta_mainstateuser");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = decryptToken("accessToken") || ""

  useEffect(() => {
    const fetchExpense = async () => {
      try {
        const res = await fetch(`${url}/api/expenses/singleexpense/${id}`, {
          method: "GET",
          Authorization: `Bearer ${token}`,
        });
        const result = await res.json();
        console.log("Expense Details", result)
        setExpense(result);
      } catch (error) {
        console.error("Error loading expense:", error);
        setExpense(null);
      }
    };

    if (id) fetchExpense();
  }, [id]);

  const handleEdit = () => {
    navigate("/edit-expense", { state: expense });
  };

  const handleDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This expense will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${url}/api/expense/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            }
          });

          if (!response.ok) {
            const err = await response.json();
            throw new Error(err?.message || "Failed to delete");
          }

          Swal.fire("Deleted!", "Expense has been deleted.", "success");
          navigate("/expenses");
        } catch (error) {
          console.error("Delete error:", error.message);
          Swal.fire(
            "Error!",
            `Failed to delete expense. ${error.message}`,
            "error"
          );
        }
      }
    });
  };

  const fetchExpenses = async () => {
    try {
      const res = await fetch(`${url}/api/expenses/all/${user.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await res.json();
      const formattedData = data.map(item => ({ ...item, isEditing: false }));
      setCustomers(formattedData.reverse());
    } catch (err) {
      console.error("Failed to fetch expenses:", err);
    }
  };
  useEffect(() => {
    fetchExpenses();
  }, []);

  if (!expense) return <p>Loading expense details...</p>;

  return (
    <>
      <div className={`open-close ${isSidebarOpen ? "open" : "closed"}`}>
        <div className="ecom-customer-detail-container">
          <div className="ecom-customer-header-detail">
            <div className="ecom-customer-header-left-container">
              <ArrowLeftIcon onClick={() => navigate("/expense")} />
              <h2 className="ecom-customer-name-highlight">
                {expense.notes?.trim() || "Expense Detail"}
              </h2>
            </div>
            <div className="ecom-customer-header-right-container">
              <PenIcon onClick={() => {
                setSelectedExpense(expense);
                setIsModalOpen(true);
              }} />
              <Trash2Icon onClick={handleDelete} />
            </div>
          </div>

          {/* Expense Details */}
          <section className="ecom-customer-section-box ecom-customer-details">
            <h4>
              <FileText size={16} style={{ marginRight: "8px" }} /> Expense Info
            </h4>
            <div className="ecom-customer-detail-grid">
              <div>
                <label>Invoice Number:</label>
                <span>{expense.invoiceNumber || "—"}</span>
              </div>
              <div>
                <label>Expense Type:</label>
                <span>{expense.expenseType || "-"}</span>
              </div>
              <div>
                <label>Category:</label>
                <span>{expense.category || "—"}</span>
              </div>
              <div>
                <label>Date:</label>
                <span>{expense.date !== "0000-00-00" ? expense.date : "—"}</span>
              </div>
              <div>
                <label>Amount:</label>
                <span>₹ {Number(expense.amount || 0).toFixed(2)}</span>
              </div>
              <div>
                <label>Customer:</label>
                <span>{expense.customer || "—"}</span>
              </div>
              <div>
                <label>Receipt:</label>
                <span>
                  {expense.receipt ? (
                    <a
                      href={
                        expense.receipt.startsWith("http")
                          ? expense.receipt
                          : `${url}/Images/Expense/${expense.receipt}`
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  ) : (
                    "—"
                  )}
                </span>
              </div>
            </div>
          </section>
        </div>
      </div>

      <ExpenseModal
        isOpen={isModalOpen}
        setIsOpen={(val) => {
          setIsModalOpen(val);
          if (!val) setSelectedExpense(null);
        }}
        editExpense={selectedExpense}
        fetchExpenses={fetchExpenses}
      />
    </>
  );
};

export default ExpenseDetail;
